/*
    Copyright (C) 2024 - Workforce Navigator - Southwest Airlines
*/

const logger = ({ req, res, error, timeTaken, headers }) => {
  console.log({
    error,
    header: headers,
    request: req,
    response: res,
    time: timeTaken
  });
};

export default logger;
